import imageLazy from './image-lazy/image-lazy'
import './jquery/jquery.min'
import './swiper/swiper-bundle.min'

imageLazy.init()
